__webpack_require__.p = "https://dev.widget.ai-assistants.myapp.com.ua/";